
import { NO_INFORMATION } from "@/data/placeholders";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PageHeadIcon extends Vue {
  @Prop({ type: String, default: undefined }) readonly icon?: string;
  @Prop({ type: String, default: undefined }) readonly content?: string;
  @Prop({ type: String, default: undefined }) readonly title?: string;
  @Prop({ type: Boolean, default: false }) readonly extend!: boolean;
  @Prop({ type: Boolean, default: false }) readonly backColor!: boolean;
  @Prop({ type: String, default: "" }) readonly noContent?: string;

  noInformaion = NO_INFORMATION;

  get contentData(): string {
    if (this.content) {
      return this.content;
    }
    return this.noContent !== "" ? this.noContent : this.noInformaion;
  }

  get contentStyles(): Object {
    if (this.content) {
      return {
        truncate: !this.extend,
        "block -mr-3 break-all": this.extend,
      };
    }
    return {};
  }
}
